module.exports = __webpack_public_path__ + "static/wpack/extracted/space-intro0801931d4d59a3ea35bcb90463b038c5.png";